import { render, staticRenderFns } from "./ContentFieldForm.vue?vue&type=template&id=405dfbdb"
import script from "./ContentFieldForm.vue?vue&type=script&lang=js"
export * from "./ContentFieldForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports